import { Box } from "native-base";
import React from "react";
const SeparatorLine = (props) => {
    return <Box backgroundColor={"primaryDark"} height={"1px"} {...props}/>;
};
export default SeparatorLine;
